import React from "react";
import '../../styles/common/piano-key.scss';
import {iconImages} from "../../config/config";

export type Key = "C" | "D" | "B";
interface IPianoKeyProps{
  pianoKey: Key
}

export default function PianoKey({pianoKey}: IPianoKeyProps) {
  const imageSrc = getImageSourceForKey(pianoKey);
  return (
    <div className="piano-key">
      <div className="image-and-text">
        <img src={imageSrc} alt="piano key image"/>
        <div className="piano-key-letter">{pianoKey}</div>
      </div>
    </div>
  );
}

function getImageSourceForKey(key: Key){
  switch (key) {
    case "B": return iconImages.bKey;
    case "C": return iconImages.cKey;
    case "D": return iconImages.dKey;
    default: return iconImages.dKey;
  }
}